import AppConstants from "../../../constants/AppConstants";
import DocumentStore from "../../../document/DocumentStore";
import { COMMANDS } from "../../../document/commands";
import UIActions from "../../../actions/UIActions";
import UserActions from "../../../actions/UserActions";
import UserEventConstants from "../../../constants/UserEventConstants";

const { MODAL_ACTION_CONFIRM, 
  SITE_ITEM_PAGE, 
  SITE_ITEM_WP_PAGE, 
  SITE_ITEM_BLOCK, 
  SITE_ITEM_CANVAS_SET,
} = AppConstants;
const { EVENT_PAGE_DELETE, EVENT_SITE_CANVAS_DELETE, EVENT_CANVAS_SET_DELETE } = UserEventConstants;

/**
 * Remove Item
 * Removes a Pages Panel item based on its type and source.
 * @param {Object} props
 * @param {string} props.source - Array map for page, block, or canvas set
 * @param {string} props.type - page, block, or canvas set
 * @param {string} props.name - The name of the item
 * @param {string} props.id - The ID of the item
 * @param {string} props.slug - The slug of the item
 */

const removeItem = ({ source, type, name, id, slug }) => {
  if ([SITE_ITEM_PAGE, SITE_ITEM_WP_PAGE].includes(type) && source) {
    UIActions.modalOpen(MODAL_ACTION_CONFIRM, {
      title: `Delete ${name}`,
      question: `Are you sure you want to delete the page '${name}'?`,
      message: "This removes a page from your design and cannot be undone.",
      confirmBtn: "Delete",
      confirmAction: () => {
        DocumentStore.dispatch({ type: COMMANDS.REMOVE_PAGE, payload: { id } });
        UserActions.trackEvent({ event: EVENT_PAGE_DELETE, meta: { page: slug, id } });
      },
    });
  }
  if (type === SITE_ITEM_BLOCK && source) {
    UIActions.modalOpen(MODAL_ACTION_CONFIRM, {
      title: "Delete Site Canvas",
      question: "Are you sure you want to delete this site canvas?",
      message:
        "This removes a site canvas from design and will affect all pages the canvas was used on.",
      confirmBtn: "Delete",
      confirmAction: () => {
        DocumentStore.dispatch({ type: COMMANDS.REMOVE_SITE_BLOCK, payload: { block: source } });
        UserActions.trackEvent({ event: EVENT_SITE_CANVAS_DELETE, meta: { block: slug } });
      },
    });
  }
  if (type === SITE_ITEM_CANVAS_SET && source) {
    UIActions.modalOpen(MODAL_ACTION_CONFIRM, {
      title: "Delete Canvas Set",
      question: "Are you sure you want to delete this canvas set?",
      message:
        "This removes this canvas set from your design and will affect all pages where it was used.",
      confirmBtn: "Delete Canvas Set",
      confirmAction: () => {
        DocumentStore.dispatch({ type: COMMANDS.REMOVE_CANVAS_SET, payload: { id } });
        UserActions.trackEvent({ event: EVENT_CANVAS_SET_DELETE, meta: { canvasSet: slug } });
      },
    });
  }
};

export default removeItem;
